import React from "react";
import "./GPTeam.css";

const committeeMembers = [
  { name: "श्री प्रशांत देवराज जी शेटे", designation: "सदस्य ,गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-9764120461", imageUrl: "/images/prashant.jpg" },
  { name: "श्री मुकेश सुरेशजी मरडवार", designation: "सदस्य ,गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-9689344917 ", imageUrl: "/images/mukesh.jpg" },
  { name: "श्री इंद्रकुमार पारनु तागडे", designation: "सदस्य गट ग्रामपंचायत सावंगी-घोगली", phone: "+91 -8766435009", imageUrl: "/images/indrakumar.jpg" },
  { name: "सौ रंजनाताई शामूजी चोखाद्रे", designation: "सदस्य गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-8766435009 ", imageUrl: "/images/ranjana.jpg" },
  { name: "सौ मीनाताई मधुकरजी धरममाळी", designation: "सदस्य गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-9372699398 ", imageUrl: "/images/mina.jpg" },
  { name: "सौ कुमुदताई रविंद्र बागडे", designation: "सदस्य गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-9673191716 ", imageUrl: "/images/kumudtai.jpg" },
  { name: "सौ शुभांगी लालाजी धरममाळी", designation: " सदस्य गट ग्रामपंचायत सावंगी-घोगली", phone: "+91-9623807062 ", imageUrl: "/images/shubhangi.jpg" },
  { name: "सौ कविता मेश्राम", designation: "मुख्याध्यापक घोगली", phone: "+91-9623782269 ", imageUrl: "/images/kavita.jpg" },
  { name: "सौ कालिंदी  जिचकार ", designation: " मुख्याधापक ", phone: "+91", imageUrl: "/images/kalind.jpg" },
  { name: "सौ अरुणाबाई हेलोंडे ", designation: "अंगणवाडी सेविका सावंगी", phone: "+91", imageUrl: "/images/arunabai.jpg" },
  { name: "सौ मायाबाई कडू", designation: "अंगणवाडी सेविका सावंगी", phone: "+91", imageUrl: "/images/mayabai.jpg" },
  { name: "सौ सुनंदा मेघराज तागडे", designation: "अंगणवाडी सेविका घोगली", phone: "+917620668576", imageUrl: "/images/baiji.jpg" },
  { name: "श्री मनोज पारसे  ", designation: "ग्रामपंचायत संगणकपरीचालक", phone: "+8999823216", imageUrl: "/images/manoj.jpg" },
];

// 🆕 कर्मचारी सेक्शन
const employeeMembers = [

  { name: "श्री मंगेश भोतमांगे", designation: "पाणीपुरवठा कर्मचारी", phone: "+917972782556", imageUrl: "/images/mangesh.jpg" },
  { name: "श्री राहुल सावनलाल यादव", designation: "सफाई कर्मचारी", phone: "+918982694869", imageUrl: "/images/rahul.jpg" },
  { name: "श्री आदित्य बागडे ", designation: "ग्रामपंचायत कर्मचारी", phone: "+919923216557", imageUrl: "/images/aditya.jpg" },

];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img src="/images/sj1.jpg" alt="Emblem" className="gp-logo" />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">The Governing Body — Committed to Community Service</p>
      </div>

      {/* COMMITTEE SECTION */}
      <div className="gp-grid">
        {committeeMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img src={member.imageUrl} alt={member.name} className="gp-photo" />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* 🆕 EMPLOYEE HEADING */}
      <h1 className="gp-title" style={{ marginTop: "60px" }}>ग्रामपंचायत कर्मचारी</h1>

      {/* EMPLOYEE SECTION */}
      <div className="gp-grid">
        {employeeMembers.map((emp, index) => (
          <div key={index} className="gp-card">
            <img src={emp.imageUrl} alt={emp.name} className="gp-photo" />
            <h2 className="gp-name">{emp.name}</h2>
            <p className="gp-designation">{emp.designation}</p>
            <p className="gp-phone">📞 {emp.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
